import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Card, Statistic } from 'antd';
import { routePaths } from 'router';
import { buildPathWithFilters } from 'shared/utils/filters/build-path-with-filters';
import styles from './future-payments-totals.module.scss';
import type { IFuturePaymentsTotalsProps } from './types';

export const FuturePaymentsTotals: React.FC<IFuturePaymentsTotalsProps> = (props) => {
  const { totals } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Card>
        <Statistic
          title={t('future-payments:estimated_income')}
          value={totals.estimatedIncome}
          suffix='€'
          precision={1}
        />
      </Card>
      <Card>
        <Statistic
          title={t('future-payments:overdue_invoices_count')}
          value={totals.overdueInvoicesCount}
          suffix={
            <Link className={styles.showLink} to={buildPathWithFilters(routePaths.invoices, { overdue: true })}>
              {t('common:show')}
            </Link>
          }
        />
      </Card>
      <Card>
        <Statistic
          title={t('future-payments:overdue_invoices_amount')}
          value={totals.overdueInvoicesAmount}
          suffix='€'
          precision={1}
        />
      </Card>
      <Card>
        <Statistic title={t('future-payments:problem_invoices_count')} value={totals.withProblemInvoicesCount} />
      </Card>
      <Card>
        <Statistic
          title={t('future-payments:problem_invoices_amount')}
          value={totals.withProblemInvoicesAmount}
          suffix='€'
          precision={1}
        />
      </Card>
    </div>
  );
};
